<template>
  <div class="cards">
    <div
      class="card"
      :class="item.classname"
      v-for="item in items"
      :key="item.key"
    >
      <h3 class="title--dark">{{item.title}}</h3>
      <p class="card__text">{{item.text}}</p>
      <div class="card__img">
        <img :src="require(`../../assets/four-card-feature/${item.image_url}`)" alt="" >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    items: {
      type: Array,
      default: () => ([]),
      requred: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.cards {
  .card + .card {
    margin-top: var(--sm-spacer);
  }
  @media(min-width: 60em) {
    display: grid;
    grid-gap: var(--sm-spacer);
    grid-template-columns: repeat(3, minmax(25rem, 1fr));
    grid-template-areas: "a b d" "a c d";

    .card + .card {
      margin: 0;
    }
  }

  .card {
    padding: var(--sm-spacer);

    box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.3);
    background-color: var(--white);
    border-radius: var(--border-radius);

    display: grid;

    &__text {
      color: var(--grayish-blue);
    }

    .title--dark {
      text-transform: capitalize;
      font-size: var(--fs-h1);
      margin-bottom: var(--border-radius);
    }

    &__img {
      place-self: flex-end;
      padding-top: var(--sm-spacer);
    }

    &--supervisor {
      border-top: 3px solid var(--cyan);
      grid-area: a;
      align-self: center
    }

    &--team {
      border-top: 3px solid var(--red);
      grid-area: b;
    }

    &--karma {
      border-top: 3px solid var(--orange);
      grid-area: c;
    }

    &--calculator {
      border-top: 3px solid var(--blue);
      grid-area: d;
      align-self: center
    }

    transition: all 350ms linear;

    &:hover {
      cursor: pointer;
      box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
